module.exports = __webpack_public_path__ + "static/diversity-c1caaeb89063f7e8848125b7439b66af.png";